import React from 'react'
import Combobox from 'react-widgets/lib/Combobox'
import { filterAirports } from './helpers'

const CityPair = ({from, to, airports, loading, onDestinationChange, type, l}) => {
  const airportsFrom = airports.filter(x => x.airportRef !== to)
  const airportsTo = airports.filter(x => x.airportRef !== from)

  return (
    <div>
      <label>{l.from.label}:</label>
      <Combobox
        data={airportsFrom}
        defaultValue={from}
        valueField='airportRef'
        textField='formattedName'
        suggest={true}
        filter={filterAirports}
        groupBy='countryName'
        busy={loading}
        onChange={onDestinationChange.bind(undefined, `from${type}`)}
        placeholder={l.from.placeholder}
      />
      <label>{l.to.label}:</label>
      <Combobox
        data={airportsTo}
        defaultValue={to}
        valueField='airportRef'
        textField='formattedName'
        suggest={true}
        filter={filterAirports}
        groupBy='countryName'
        busy={loading}
        onChange={onDestinationChange.bind(undefined, `to${type}`)}
        placeholder={l.to.placeholder}
      />
    </div>
  )
}

export default CityPair



/** WEBPACK FOOTER **
 ** ./src/CityPair.js
 **/